import React from "react";
import {IRouteParams} from "../../../contracts/router";
import {useLocation, useParams} from "react-router-dom";
import PageHeader from "../../Elements/PageHeader";
import {IRouterListToData} from "../../../contracts/data/router";
import CouponForm from "../../../forms/dashboard/coupon/CouponForm";


const CreateOrUpdateFormCoupon:React.FC = () => {
    const params: IRouteParams = useParams();
    const location = useLocation<IRouterListToData>()

    return(
        <React.Fragment>
            <PageHeader title={params.type! === 'create' ? "کد تخفیف جدید" : "ویرایش کد تخفیف"} isBackBtn urlBackBtn={`${location?.state?.page}?page_num=${params?.type === 'edit' ? location?.state?.page_num : 1}`}/>
            <div>
                <CouponForm formType={params?.type} />
            </div>
        </React.Fragment>
    )
}

export default CreateOrUpdateFormCoupon